import { HStack } from '@chakra-ui/react';
import { Link } from '@chakra-ui/next-js';
import isEqual from 'lodash/isEqual';
import { getSearchPath, getTabNameFromUrlPath } from '@habity/services';
import { NestedSearch, SearchTab, TabButtonType } from '@habity/types';
import { useAgency } from '~/hooks/useAgency';
import { useUser } from '~/hooks/useUser';
import { omitNullKeys } from '~/lib/utils';
import { useHomesStore } from '~/store/useHomesStore';
import { useFilters } from '~/hooks/useFilters';
import { SuggestionsButtonList } from '../ButtonList';
import { SuggestionsButton } from '../Button';

interface CurationsTabContentProps {
  buttons?: TabButtonType[];
  tab?: SearchTab;
}

export const CurationsTabContent = ({
  buttons,
  tab,
}: CurationsTabContentProps = {}) => {
  const filters = useHomesStore((state) => state.filters);
  const { getCuratedButtons } = useAgency();
  const { user } = useUser();
  const { performSearch } = useFilters();

  // Use provided buttons or default to home curations
  const curatedButtons = buttons ?? getCuratedButtons(!!user);

  const getButtonSearchPath = (buttonFilters: Partial<NestedSearch>) => {
    if (typeof window === 'undefined') return '';

    const searchPath = getSearchPath({
      filters: buttonFilters,
      tab: tab ?? getTabNameFromUrlPath(window.location.pathname),
    });
    return searchPath;
  };

  if (!curatedButtons || curatedButtons.length === 0) return null;

  return (
    <HStack mb="1">
      <SuggestionsButtonList>
        {curatedButtons.map((n, index) => (
          <Link
            key={index}
            href={getButtonSearchPath(n.key)}
            onClick={(e) => e.preventDefault()}
            whiteSpace="nowrap"
            _hover={{
              textDecoration: 'none',
            }}
          >
            <SuggestionsButton
              key={index}
              icon={n.icon}
              label={n.title}
              isActive={isEqual(omitNullKeys(filters), omitNullKeys(n.key))}
              onClick={() => {
                const cleanedFilters = omitNullKeys(filters);
                const cleanedKey = omitNullKeys(n.key);
                const isActive = isEqual(cleanedFilters, cleanedKey);
                performSearch({
                  filters: isActive ? null : { ...n.key },
                  includeExistingFilters: false,
                });
              }}
            />
          </Link>
        ))}
      </SuggestionsButtonList>
    </HStack>
  );
};
